import { render, staticRenderFns } from "./retail-info-detail.vue?vue&type=template&id=558b9e4f"
import script from "./retail-info-detail.vue?vue&type=script&lang=js"
export * from "./retail-info-detail.vue?vue&type=script&lang=js"
import style0 from "./retail-info-detail.vue?vue&type=style&index=0&id=558b9e4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports